import React from 'react';
import { Tabs } from 'antd';
import { useAuth } from '../../contexts/AuthContext';
import { PERMISSIONS } from '../../config/permissions';
import HierarchyView from '../../components/rbac/HierarchyView';
import LevelsManagement from '../../components/rbac/LevelsManagement';
import PageBreadcrumbs from '../../components/common/PageBreadcrumbs';

/**
 * Hierarchy Page - Organization chart and level management
 */
export default function HierarchyPage() {
  const { hasPermission, isSuperAdmin } = useAuth();

  const canViewHierarchy = hasPermission(PERMISSIONS.RBAC_HIERARCHY_VIEW);
  const canManageLevels = isSuperAdmin;

  if (!canViewHierarchy) {
    return (
      <div className="min-h-0 flex flex-col flex-1 h-full">
        <div className="flex-1 min-h-0 overflow-y-auto p-4 sm:p-6">
          <div className="rounded-xl border border-red-200 bg-red-50 p-6 text-center">
            <h2 className="text-xl font-semibold text-red-800 mb-2">Access Denied</h2>
            <p className="text-red-600">
              You don't have permission to view the organization hierarchy.
            </p>
          </div>
        </div>
      </div>
    );
  }

  const items = [
    {
      key: 'chart',
      label: 'Organization Chart',
      children: (
        <div className="p-4 sm:p-6 min-h-[400px]">
          <HierarchyView />
        </div>
      ),
    },
    ...(canManageLevels ? [{
      key: 'management',
      label: 'Manage Levels',
      children: (
        <div className="p-4 sm:p-6">
          <LevelsManagement />
        </div>
      ),
    }] : []),
  ];

  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden min-h-0 flex flex-col flex-1 h-full">
      <div className="shrink-0">
        <PageBreadcrumbs />
      </div>
      <div className="flex-1 min-h-0 overflow-y-auto px-2 sm:px-4">
        <Tabs
          defaultActiveKey="chart"
          items={items}
          className="custom-tabs"
        />
      </div>
    </div>
  );
}
